export default __webpack_public_path__ + "static/media/user.d54ae6c5.svg";